<template>
  <div class="v-app">
    <router-view class="v-router"></router-view>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>
